import { render, staticRenderFns } from "./topUser.vue?vue&type=template&id=6a7c8f42&scoped=true&"
import script from "./topUser.vue?vue&type=script&lang=ts&"
export * from "./topUser.vue?vue&type=script&lang=ts&"
import style0 from "./topUser.vue?vue&type=style&index=0&id=6a7c8f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7c8f42",
  null
  
)

export default component.exports